import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { SavedListingReportResource } from "api/resource/saved-listing-report";
import { loginReset } from "./authentication";

/**
 * Saved Properties Activity report (statsSavedProperties.cfm) — MAX-3886. Read-only; the endpoint
 * returns the full date-filtered list, paged/sorted client-side by the shared Table. State is a flat
 * display-only array (no normalization).
 */
export interface SavedListingsReportState {
	loading?: boolean;
	error?: string | null;
	loaded: boolean;
	rows: SavedListingReportResource[];
}

const initialState: SavedListingsReportState = {
	loaded: false,
	rows: [],
};

const fetchSavedListingsReport = createAsyncThunk(
	"savedListingsReport/fetch",
	async (payload: { startDate: string; endDate: string }, thunkAPI) => {
		thunkAPI.dispatch(savedListingsReportLoading());
		const result = api.getSavedListingsReport(payload.startDate, payload.endDate);
		result
			.then((rows) => thunkAPI.dispatch(savedListingsReportLoaded(rows)))
			.catch((error) => thunkAPI.dispatch(savedListingsReportFailed(error)));
		return result;
	}
);

export const savedListingsReportSlice = createSlice({
	name: "savedListingsReport",
	initialState,
	reducers: {
		savedListingsReportLoading(state) {
			state.loading = true;
		},
		savedListingsReportLoaded(state, action: PayloadAction<SavedListingReportResource[]>) {
			state.loading = false;
			state.error = null;
			state.loaded = true;
			state.rows = action.payload;
		},
		savedListingsReportFailed(state, action: PayloadAction<any>) {
			state.loading = false;
			state.error = action.payload && action.payload.message;
		},
	},
	extraReducers(builder) {
		builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
	},
});

export const {
	savedListingsReportLoading,
	savedListingsReportLoaded,
	savedListingsReportFailed,
} = savedListingsReportSlice.actions;

export { fetchSavedListingsReport };
